import { render, staticRenderFns } from "./PerformanceWidget.vue?vue&type=template&id=7564cfc8"
import script from "./PerformanceWidget.vue?vue&type=script&lang=js"
export * from "./PerformanceWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports